import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const logout = css`
  svg {
    transform: rotate(-90deg);
    width: ${rem(20)};
    height: ${rem(20)};
  }
`

const menuStyle = () => theme => css`
  min-width: ${rem(185)};
  color: ${theme.color.monochrome.black};
  border-radius: ${rem(8)};

  [role='menuitem'] {
    padding-left: ${rem(14)};
    padding-right: ${rem(14)};
    // Overwrite hover styles in menu item, excluding header
    &[tabindex='0']:hover,
    &.highlighted {
      background-color: ${theme.color.monochrome.superLight} !important;
    }
  }

  a {
    color: ${theme.color.monochrome.black};
  }
`

const avatarContainer = css`
  position: relative;
  cursor: pointer;
`

export const styles = {
  logout,
  menuStyle,
  avatarContainer,
}
